import store from "../redux/store";
import { browserLogger } from "./browserLogger";


export const getQueuedLogs = () => {
  return logQueue;
};

export const clearLogQueue = () => {
  logQueue = [];
};


export const logSpan = (logTitle, spanContext, severity, ...attributes) => {
  try {
    const userData = store.getState().userReducer.userData;
    const currentSelectedSheet = store.getState().sheetReducer.currentSelectedSheet;
    let newAttributes = [];

    attributes.forEach((attribute) => {
      if (attribute === undefined || attribute === null) {
        newAttributes.push({});
      } else {
        let json = JSON.stringify(processNestedObject(attribute), getCircularReplacer(), 2);
        newAttributes.push(JSON.parse(json));
      }
    });

    // Emit via browserLogger — it auto-enriches with browser context,
    // page URL, source location, and trace context
    const extra = {
      trace_id: spanContext?.traceId,
      span_id: spanContext?.spanId,
      user_email: userData?.email,
      sheet_id: currentSelectedSheet?.id ?? '',
      attr: JSON.stringify(newAttributes),
    };

    const level = (severity || 'INFO').toUpperCase();
    if (level === 'ERROR') {
      browserLogger.error(logTitle, null, extra);
    } else if (level === 'WARN') {
      browserLogger.warn(logTitle, extra);
    } else {
      browserLogger.info(logTitle, extra);
    }

  } catch (error) {
    console.error("Error in log span", error);
  }
};

function getCircularReplacer() {
  const seen = new WeakSet();
  return function (key, value) {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) return "[Circular]";
      seen.add(value);
    }
    return value;
  };
}

function processNestedObject(input, seen = new WeakSet(), depth = 0, maxDepth = 50) {
  if (depth > maxDepth || input === null || typeof input !== 'object') {
    return depth > maxDepth ? '[MaxDepthExceeded]' : input;
  }

  if (seen.has(input)) {
    return '[Circular]';
  }
  seen.add(input);

  if (Object.prototype.hasOwnProperty.call(input, 'allChildrenCount')) {
    return {
      data: input.data,
      rowIndex: input.rowIndex,
    };
  }

  if (Array.isArray(input)) {
    return input.map(item => processNestedObject(item, seen, depth + 1, maxDepth));
  }

  const newObject = {};
  for (let key in input) {
    if (Object.prototype.hasOwnProperty.call(input, key)) {
      newObject[key] = processNestedObject(input[key], seen, depth + 1, maxDepth);
    }
  }

  return newObject;
}
